// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kit-demo-container {
  max-width: 920px;
  margin: 0 auto;
  padding: 2.5rem;
}

.kit-demo-header {
  text-align: center;
  margin-bottom: 3.5rem;
}

.kit-demo-header h1 {
  font-size: 2.8rem;
  color: var(--primary-teal);
  margin-bottom: 0.6rem;
  font-weight: 700;
}

.subtitle {
  color: var(--text-medium);
  font-size: 1.1rem;
}

.error-banner {
  background: linear-gradient(135deg, var(--error) 0%, #c62828 100%);
  color: white;
  padding: 1.2rem 1.5rem;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 12px rgba(229, 115, 115, 0.3);
}

.error-banner .close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 1.6rem;
  cursor: pointer;
  padding: 0 0.6rem;
  transition: all 0.3s ease;
}

.error-banner .close-btn:hover {
  transform: scale(1.1);
}

.kit-demo-content {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.section {
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.95) 0%, rgba(10, 42, 48, 0.98) 100%);
  border: 1px solid rgba(95, 184, 165, 0.2);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.15);
  transition: all 0.3s ease;
}

.section:hover {
  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.25);
  border-color: rgba(95, 184, 165, 0.3);
}

.section h2 {
  color: var(--accent-mint);
  margin-bottom: 1.8rem;
  font-size: 1.7rem;
  font-weight: 600;
}

/* Wallet Grid */
.wallet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1.2rem;
  margin-bottom: 1.8rem;
}

.wallet-item {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.2rem;
  border: 2px solid rgba(95, 184, 165, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(10, 42, 48, 0.5);
}

.wallet-item:hover:not(.disabled) {
  border-color: var(--primary-teal-active);
  background: rgba(26, 109, 122, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(95, 184, 165, 0.2);
}

.wallet-item.selected {
  border-color: var(--accent-mint);
  background: linear-gradient(135deg, rgba(95, 184, 165, 0.15) 0%, rgba(42, 141, 156, 0.15) 100%);
}

.wallet-item.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.wallet-item img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid rgba(95, 184, 165, 0.3);
}

.wallet-info {
  flex: 1;
}

.wallet-name {
  font-weight: 600;
  color: white;
  margin-bottom: 0.3rem;
  font-size: 1rem;
}

.wallet-status {
  font-size: 0.8rem;
  color: var(--text-light);
  font-weight: 500;
}

.wallet-status.installed {
  color: var(--success);
}

.wallet-status.not-detected {
  color: var(--warning);
}

.wallet-status.unsupported {
  color: var(--error);
}

/* Connected Info */
.connected-info {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.info-card {
  background: rgba(10, 42, 48, 0.6);
  border: 1px solid rgba(95, 184, 165, 0.2);
  border-radius: 12px;
  padding: 1.8rem;
  transition: all 0.3s ease;
}

.info-card:hover {
  border-color: rgba(95, 184, 165, 0.35);
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 0;
  border-bottom: 1px solid rgba(95, 184, 165, 0.1);
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  color: var(--accent-mint);
  font-weight: 600;
  font-size: 0.95rem;
}

.info-row .value {
  color: white;
  font-family: 'Monaco', 'Menlo', monospace;
}

.info-row .value.address {
  font-size: 0.9rem;
  word-break: break-all;
  text-align: right;
  max-width: 450px;
}

/* Form */
.form-group {
  margin-bottom: 1.2rem;
}

.form-group label {
  display: block;
  color: var(--accent-mint);
  font-weight: 600;
  margin-bottom: 0.6rem;
  font-size: 0.95rem;
}

.input {
  width: 100%;
  padding: 0.9rem;
  background: rgba(10, 42, 48, 0.8);
  border: 1px solid rgba(95, 184, 165, 0.3);
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.input:focus {
  outline: none;
  border-color: var(--accent-mint);
  box-shadow: 0 0 0 3px rgba(95, 184, 165, 0.15);
  background: rgba(10, 42, 48, 0.9);
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

/* Buttons */
.btn {
  padding: 0.9rem 1.8rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.2);
}

.btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.3);
}

.btn-secondary {
  background: rgba(95, 184, 165, 0.15);
  color: var(--accent-mint);
  border: 1px solid rgba(95, 184, 165, 0.3);
}

.btn-secondary:hover:not(:disabled) {
  background: rgba(95, 184, 165, 0.25);
  border-color: var(--accent-mint);
  transform: translateY(-2px);
}

/* Result Cards */
.result-card {
  margin-top: 1.8rem;
  padding: 1.8rem;
  border-radius: 14px;
  border: 2px solid;
  transition: all 0.3s ease;
}

.result-card.success {
  border-color: var(--accent-mint);
  background: linear-gradient(135deg, rgba(95, 184, 165, 0.08) 0%, rgba(42, 141, 156, 0.08) 100%);
}

.result-card:hover {
  box-shadow: 0 4px 16px rgba(95, 184, 165, 0.2);
}

.result-card h3 {
  color: var(--accent-mint);
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  font-weight: 600;
}

.result-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.result-row {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.result-label {
  color: var(--accent-mint);
  font-weight: 600;
  font-size: 0.95rem;
}

.result-value {
  color: white;
  font-family: 'Monaco', 'Menlo', monospace;
  word-break: break-all;
  background: rgba(10, 42, 48, 0.7);
  padding: 0.9rem;
  border-radius: 8px;
  border: 1px solid rgba(95, 184, 165, 0.2);
}

.result-value.signature {
  font-size: 0.88rem;
}

.explorer-link {
  color: var(--accent-mint);
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.3s ease;
}

.explorer-link:hover {
  color: var(--primary-teal-active);
  transform: translateX(3px);
}

/* Responsive */
@media (max-width: 768px) {
  .kit-demo-container {
    padding: 1.2rem;
  }

  .wallet-grid {
    grid-template-columns: 1fr;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.6rem;
  }

  .info-row .value.address {
    text-align: left;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/KitDemo.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,2FAA2F;EAC3F,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,+FAA+F;AACjG;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4FAA4F;EAC5F,YAAY;AACd;;AAEA;EACE,kGAAkG;EAClG,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+FAA+F;AACjG;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".kit-demo-container {\n  max-width: 920px;\n  margin: 0 auto;\n  padding: 2.5rem;\n}\n\n.kit-demo-header {\n  text-align: center;\n  margin-bottom: 3.5rem;\n}\n\n.kit-demo-header h1 {\n  font-size: 2.8rem;\n  color: var(--primary-teal);\n  margin-bottom: 0.6rem;\n  font-weight: 700;\n}\n\n.subtitle {\n  color: var(--text-medium);\n  font-size: 1.1rem;\n}\n\n.error-banner {\n  background: linear-gradient(135deg, var(--error) 0%, #c62828 100%);\n  color: white;\n  padding: 1.2rem 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 2.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 4px 12px rgba(229, 115, 115, 0.3);\n}\n\n.error-banner .close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.6rem;\n  cursor: pointer;\n  padding: 0 0.6rem;\n  transition: all 0.3s ease;\n}\n\n.error-banner .close-btn:hover {\n  transform: scale(1.1);\n}\n\n.kit-demo-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.section {\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.95) 0%, rgba(10, 42, 48, 0.98) 100%);\n  border: 1px solid rgba(95, 184, 165, 0.2);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.15);\n  transition: all 0.3s ease;\n}\n\n.section:hover {\n  box-shadow: 0 8px 24px rgba(17, 69, 77, 0.25);\n  border-color: rgba(95, 184, 165, 0.3);\n}\n\n.section h2 {\n  color: var(--accent-mint);\n  margin-bottom: 1.8rem;\n  font-size: 1.7rem;\n  font-weight: 600;\n}\n\n/* Wallet Grid */\n.wallet-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1.2rem;\n  margin-bottom: 1.8rem;\n}\n\n.wallet-item {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  padding: 1.2rem;\n  border: 2px solid rgba(95, 184, 165, 0.2);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: rgba(10, 42, 48, 0.5);\n}\n\n.wallet-item:hover:not(.disabled) {\n  border-color: var(--primary-teal-active);\n  background: rgba(26, 109, 122, 0.15);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(95, 184, 165, 0.2);\n}\n\n.wallet-item.selected {\n  border-color: var(--accent-mint);\n  background: linear-gradient(135deg, rgba(95, 184, 165, 0.15) 0%, rgba(42, 141, 156, 0.15) 100%);\n}\n\n.wallet-item.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.wallet-item img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 2px solid rgba(95, 184, 165, 0.3);\n}\n\n.wallet-info {\n  flex: 1;\n}\n\n.wallet-name {\n  font-weight: 600;\n  color: white;\n  margin-bottom: 0.3rem;\n  font-size: 1rem;\n}\n\n.wallet-status {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  font-weight: 500;\n}\n\n.wallet-status.installed {\n  color: var(--success);\n}\n\n.wallet-status.not-detected {\n  color: var(--warning);\n}\n\n.wallet-status.unsupported {\n  color: var(--error);\n}\n\n/* Connected Info */\n.connected-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.info-card {\n  background: rgba(10, 42, 48, 0.6);\n  border: 1px solid rgba(95, 184, 165, 0.2);\n  border-radius: 12px;\n  padding: 1.8rem;\n  transition: all 0.3s ease;\n}\n\n.info-card:hover {\n  border-color: rgba(95, 184, 165, 0.35);\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.9rem 0;\n  border-bottom: 1px solid rgba(95, 184, 165, 0.1);\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-row .label {\n  color: var(--accent-mint);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.info-row .value {\n  color: white;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.info-row .value.address {\n  font-size: 0.9rem;\n  word-break: break-all;\n  text-align: right;\n  max-width: 450px;\n}\n\n/* Form */\n.form-group {\n  margin-bottom: 1.2rem;\n}\n\n.form-group label {\n  display: block;\n  color: var(--accent-mint);\n  font-weight: 600;\n  margin-bottom: 0.6rem;\n  font-size: 0.95rem;\n}\n\n.input {\n  width: 100%;\n  padding: 0.9rem;\n  background: rgba(10, 42, 48, 0.8);\n  border: 1px solid rgba(95, 184, 165, 0.3);\n  border-radius: 10px;\n  color: white;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--accent-mint);\n  box-shadow: 0 0 0 3px rgba(95, 184, 165, 0.15);\n  background: rgba(10, 42, 48, 0.9);\n}\n\n.input::placeholder {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n/* Buttons */\n.btn {\n  padding: 0.9rem 1.8rem;\n  border: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.2);\n}\n\n.btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--primary-teal) 0%, var(--primary-teal-active) 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.3);\n}\n\n.btn-secondary {\n  background: rgba(95, 184, 165, 0.15);\n  color: var(--accent-mint);\n  border: 1px solid rgba(95, 184, 165, 0.3);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: rgba(95, 184, 165, 0.25);\n  border-color: var(--accent-mint);\n  transform: translateY(-2px);\n}\n\n/* Result Cards */\n.result-card {\n  margin-top: 1.8rem;\n  padding: 1.8rem;\n  border-radius: 14px;\n  border: 2px solid;\n  transition: all 0.3s ease;\n}\n\n.result-card.success {\n  border-color: var(--accent-mint);\n  background: linear-gradient(135deg, rgba(95, 184, 165, 0.08) 0%, rgba(42, 141, 156, 0.08) 100%);\n}\n\n.result-card:hover {\n  box-shadow: 0 4px 16px rgba(95, 184, 165, 0.2);\n}\n\n.result-card h3 {\n  color: var(--accent-mint);\n  margin-bottom: 1.2rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.result-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.result-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.result-label {\n  color: var(--accent-mint);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.result-value {\n  color: white;\n  font-family: 'Monaco', 'Menlo', monospace;\n  word-break: break-all;\n  background: rgba(10, 42, 48, 0.7);\n  padding: 0.9rem;\n  border-radius: 8px;\n  border: 1px solid rgba(95, 184, 165, 0.2);\n}\n\n.result-value.signature {\n  font-size: 0.88rem;\n}\n\n.explorer-link {\n  color: var(--accent-mint);\n  text-decoration: none;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  transition: all 0.3s ease;\n}\n\n.explorer-link:hover {\n  color: var(--primary-teal-active);\n  transform: translateX(3px);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .kit-demo-container {\n    padding: 1.2rem;\n  }\n\n  .wallet-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .info-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.6rem;\n  }\n\n  .info-row .value.address {\n    text-align: left;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
